export const SHIPPING_FEE = 10;

const IMG_NOIR_PORTE = 'https://customer-assets-agu9un31.emergentagent.net/job_hope-rebuild-2/artifacts/8k01kcub_IMG_0769.webp';
const IMG_NOIR_FRONT = 'https://customer-assets-agu9un31.emergentagent.net/job_hope-rebuild-2/artifacts/400qqh38_IMG_4670.PNG';
const IMG_NOIR_BACK = 'https://customer-assets-agu9un31.emergentagent.net/job_hope-rebuild-2/artifacts/g1f7bl6j_IMG_4671.jpg';
const IMG_BEIGE_BACK = 'https://customer-assets-agu9un31.emergentagent.net/job_hope-rebuild-2/artifacts/cuj7uzmm_IMG_4672.jpg';
const IMG_BLEU_FRONT = 'https://customer-assets-agu9un31.emergentagent.net/job_hope-rebuild-2/artifacts/39a3u68a_IMG_4661.PNG';
const IMG_BEIGE_FRONT = 'https://customer-assets-agu9un31.emergentagent.net/job_hope-rebuild-2/artifacts/l2fnnci0_IMG_4662.PNG';
const IMG_BRUN_FRONT = 'https://customer-assets-agu9un31.emergentagent.net/job_hope-rebuild-2/artifacts/zve8avnb_IMG_4663.PNG';
const IMG_BLEU_BACK = 'https://customer-assets-agu9un31.emergentagent.net/job_hope-rebuild-2/artifacts/yxm33zzh_IMG_4664.jpg';
const IMG_BRUN_BACK = 'https://customer-assets-agu9un31.emergentagent.net/job_hope-rebuild-2/artifacts/hgs69zd5_IMG_4665.jpg';

export const PRODUCTS = [
  {
    id: 'combinaison',
    name: { fr: 'Combinaison sport Fondation Enat', en: 'Fondation Enat Sport Jumpsuit' },
    description: {
      fr: 'Combinaison sport ajustée et confortable avec le logo brodé de la fondation et dos ouvert élégant. Parfaite pour l\'entraînement comme pour le quotidien. Chaque achat soutient notre mission.',
      en: 'Fitted, comfortable sport jumpsuit with the foundation\'s embroidered logo and elegant open back. Perfect for workouts and everyday wear. Every purchase supports our mission.',
    },
    price: 65,
    sizes: ['S', 'M', 'L'],
    colors: [
      { id: 'noir', label: { fr: 'Noir', en: 'Black' }, swatch: '#1A1A1A', images: [IMG_NOIR_FRONT, IMG_NOIR_BACK] },
      { id: 'beige', label: { fr: 'Beige', en: 'Beige' }, swatch: '#D8CDBB', images: [IMG_BEIGE_FRONT, IMG_BEIGE_BACK] },
      { id: 'brun', label: { fr: 'Brun', en: 'Brown' }, swatch: '#6A483F', images: [IMG_BRUN_FRONT, IMG_BRUN_BACK] },
      { id: 'bleu', label: { fr: 'Bleu', en: 'Blue' }, swatch: '#416A84', images: [IMG_BLEU_FRONT, IMG_BLEU_BACK] },
    ],
    image: IMG_BLEU_FRONT,
  },
];

export const WORN_PHOTOS = [
  IMG_NOIR_PORTE,
  'https://customer-assets-agu9un31.emergentagent.net/job_hope-rebuild-2/artifacts/d9uqro19_9FF7C63A-6585-43C9-8C22-4FE3CA82369A%202.JPG',
  'https://customer-assets-agu9un31.emergentagent.net/job_hope-rebuild-2/artifacts/fvncgc54_5EFE033F-666E-4EF1-8C0D-B24BAF23F829%202.JPG',
  'https://customer-assets-agu9un31.emergentagent.net/job_hope-rebuild-2/artifacts/eiy53m9r_5AFF5789-1263-42CE-975E-33F9F4C5E435.JPG',
];
